import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 保存放行信息
export function saveItemRelease(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/itemRelease.saveItemRelease',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取放行类型列表
export function listItemReleaseType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/itemRelease.listItemReleaseType',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询审批人信息
export function queryFirstAuditStaff(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/oaWorkflow.queryFirstAuditStaff',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询员工信息
export function queryStaffInfos(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/query.staff.infos',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取组织树
export function listOrgTree(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.listOrgTree',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}